
document.addEventListener("DOMContentLoaded", function() {
    // ==============================
    // CONTROL DEL BUCLE DE RECARGA
    // ==============================
    var RELOAD_FLAG  = 'nm_grad_reload_active';
    var RELOAD_COUNT = 'nm_grad_reload_count';
    var MAX_RELOADS  = 20; // <-- aquí mandas tú

    function resetReloadLoop() {
      sessionStorage.removeItem(RELOAD_FLAG);
      sessionStorage.removeItem(RELOAD_COUNT);
    }

    function hardReload() {
      var count = parseInt(sessionStorage.getItem(RELOAD_COUNT) || '0', 10);

      // Seguridad: NUNCA más de MAX_RELOADS recargas
      if (count >= MAX_RELOADS) {
        resetReloadLoop();
        return;
      }

      sessionStorage.setItem(RELOAD_FLAG, '1');
      sessionStorage.setItem(RELOAD_COUNT, String(count + 1));

      // Recarga fuerte de la misma URL (como escribirla en la barra)
      var currentUrl = window.location.pathname + window.location.search;
      window.location.replace(currentUrl);
    }

    // ==============================
    // 1) TU FUNCIÓN "SAGRADA"
    // ==============================
    function cleanGraduatedPacks(thenReload) {
      return fetch("/cart.js")
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (!cart || !cart.items || !cart.items.length) {
            if (thenReload) {
              // Si venimos de bucle y ya no hay nada: cortamos
              if (sessionStorage.getItem(RELOAD_FLAG) === '1') {
                resetReloadLoop();
              } else {
                hardReload();
              }
            }
            return;
          }

          var packs = {};

          cart.items.forEach(function(item) {
            var props = item.properties || {};
            var packId = props.pack_id;

            if (!packId) return;

            packId = String(packId);

            if (!packs[packId]) {
              packs[packId] = { parents: [], children: [] };
            }

            if (props._fixed_qty) {
              packs[packId].children.push(item);    // hijo (lentes)
            } else {
              packs[packId].parents.push(item);     // padre (gafa)
            }
          });

          var updates = {};

          Object.keys(packs).forEach(function(packId) {
            var group = packs[packId];
            var hasParents = group.parents.length > 0;
            var hasChildren = group.children.length > 0;

            // Solo padres o solo hijos => borrar todo el pack
            if ((hasParents && !hasChildren) || (!hasParents && hasChildren)) {
              group.parents.concat(group.children).forEach(function(item) {
                updates[item.key] = 0;
              });
            }
          });

          // === AQUÍ DECIDIMOS SI SE SIGUE RECARGANDO O SE CORTA ===
          if (!Object.keys(updates).length) {
            if (thenReload) {
              // Si estábamos en bucle pero ya no hay nada que borrar, cortamos
              if (sessionStorage.getItem(RELOAD_FLAG) === '1') {
                resetReloadLoop();
              } else {
                // Comportamiento antiguo: una sola recarga
                hardReload();
              }
            }
            return;
          }

          return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: updates })
          })
            .then(function() {
              if (thenReload) {
                hardReload();
              }
            })
            .catch(function(err) {
              console.error("Error limpiando packs incompletos:", err);
              if (thenReload) {
                hardReload();
              }
            });
        })
        .catch(function(err) {
          console.error("Error leyendo el carrito:", err);
          if (thenReload) {
            hardReload();
          }
        });
    }

    // ==============================
    // 2) INICIAL: limpieza silenciosa
    //    o seguimos el bucle si estaba activo
    // ==============================
    if (sessionStorage.getItem(RELOAD_FLAG) === '1') {
      // Venimos de una recarga del bucle -> seguimos con thenReload=true
      cleanGraduatedPacks(true);
    } else {
      // Primera carga normal
      cleanGraduatedPacks(false);
    }

    // ==============================
    // 3) CLICK EN ELIMINAR DEL CARRITO
    // ==============================
    document.addEventListener("click", function(e) {
      var btn = e.target.closest(".cart-items__remove");
      if (!btn) return;

      // Arranca el bucle de recargas (máx 30)
      sessionStorage.setItem(RELOAD_FLAG, '1');
      sessionStorage.setItem(RELOAD_COUNT, '0');

      // Dejamos que el tema haga su /cart/update primero
      setTimeout(function() {
        cleanGraduatedPacks(true);
      }, 500);
    });

    // ==============================
    // 4) OBSERVER DEL DRAWER (tu segundo script "sagrado")
    // ==============================
    var cartDrawerContent = document.querySelector('.cart-drawer__content');
    if (!cartDrawerContent) return;

    function hasGraduadaRow() {
      return !!cartDrawerContent.querySelector(
        '.cart-items__table-row[data-has-graduada="true"]'
      );
    }

    var lastHadGraduada = hasGraduadaRow();
    var isRedirecting = false;

    var observer = new MutationObserver(function () {
      if (isRedirecting) return;

      var nowHasGraduada = hasGraduadaRow();

      // Antes había una graduada y ahora ya no => nos aseguramos recarga fuerte también
      if (lastHadGraduada && !nowHasGraduada) {
        isRedirecting = true;

        // Activamos el bucle si no estaba
        sessionStorage.setItem(RELOAD_FLAG, '1');
        if (!sessionStorage.getItem(RELOAD_COUNT)) {
          sessionStorage.setItem(RELOAD_COUNT, '0');
        }

        hardReload();
      }

      lastHadGraduada = nowHasGraduada;
    });

    observer.observe(cartDrawerContent, {
      childList: true,
      subtree: true
    });
  });


//   nota
  document.addEventListener('DOMContentLoaded', function () {

    function syncGraduatedPropsToCartNote() {
      fetch('/cart.js')
        .then(function(r){ return r.json(); })
        .then(function(cart){
          if (!cart || !cart.items) return;

          var packs = {};
          var hasGraduada = false;

          cart.items.forEach(function(item){
            var props = item.properties || {};
            if (!props) return;

            var packId = props.pack_id;
            if (packId) {
              packId = String(packId);
              if (!packs[packId]) {
                packs[packId] = { parent: null, child: null };
              }

              // Padre: gafas (Graduada: "Sí")
              if (props.Graduada === 'Sí') {
                packs[packId].parent = item;
                hasGraduada = true;
              }

              // Hijo: lentes (_fixed_qty)
              if (props._fixed_qty) {
                packs[packId].child = item;
              }
            }
          });

          var newNote = '';

          if (hasGraduada) {
            var blocks = [];

            Object.keys(packs).forEach(function(packId){
              var pack = packs[packId];
              if (!pack.parent && !pack.child) return;

              var parts = [];

              // Título del pack
              var title = '';
              if (pack.parent) {
                title = pack.parent.product_title || pack.parent.title || '';
              } else if (pack.child) {
                title = pack.child.product_title || pack.child.title || '';
              }

              if (title) {
                parts.push('Pack graduado: ' + title);
              }

              // Preferimos las propiedades del hijo (receta)
              var propsSource = {};
              if (pack.child && pack.child.properties) {
                propsSource = pack.child.properties;
              } else if (pack.parent && pack.parent.properties) {
                propsSource = pack.parent.properties;
              }

              Object.keys(propsSource).forEach(function(key){
                if (key === 'pack_id' || key === '_fixed_qty' || key === 'Graduada') return;

                var value = propsSource[key];
                if (value == null) return;
                value = String(value).trim();
                if (!value) return;

                parts.push(key + ': ' + value);
              });

              if (parts.length) {
                // Todo el pack en UNA sola línea
                blocks.push(parts.join(' | '));
              }
            });

            // Si hay varios packs, los juntamos en una sola línea también
            newNote = blocks.join(' || ');
          }

          var currentNote = cart.note || '';

          // Si NO hay ningún Graduada: "Sí" => borramos nota si existe
          if (!hasGraduada) {
            if (!currentNote) return; // nada que borrar
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: '' })
            });
          }

          // Si hay graduadas pero la nota ya es la misma, no tocamos nada
          if (newNote === currentNote || !newNote) {
            return;
          }

          // Actualizamos la nota con todas las propiedades (una sola línea)
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: newNote })
          });
        })
        .catch(function(err){
          console.error('Error sincronizando notas de graduadas:', err);
        });
    }

    // Llamada inicial
    syncGraduatedPropsToCartNote();

    // Re-sincronizar cuando se elimina algo o se cambia cantidad
    document.addEventListener('click', function(e){
      if (
        e.target.closest('.cart-items__remove') ||
        e.target.closest('.quantity-plus') ||
        e.target.closest('.quantity-minus')
      ) {
        setTimeout(syncGraduatedPropsToCartNote, 800);
      }
    });
  });
